var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"name":"home"}},[(_vm.loaded)?_c('div',[_c('div',[_c('div',{staticClass:"custom-table-container tableContainer"},[_c('Samples-summary-table',{attrs:{"store":_vm.customStore}})],1)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }